import http from './http';
import { formataDataWebMethodParaString } from './util';
import CONSTANTS from '../constants';

if (process.env.NODE_ENV === 'development' && !window.__token_financiamento__) {
    // window.__token_financiamento__ = "mDE0f==gYVJlRNdkWPNmRkRVTqZkRVtGchdlRShnUrZFbVVUNXVFVVhnUWpkMadUNV5kasRnWVVzaWFTQ1cVVk5kUspkVZdWP9YGMFRUb";
    // window.__token_tokenFiador__= "D6B2C581777AE1B570DDB8490152C191";
    // window.__solSeq__=167;
    // console.warn('TOKEN DE TESTE');
}

let _listNacionalidade = [];

//este token eh setado na View.cshtml
var _token = window.__token_financiamento__;
//este token eh setado na View.cshtml
var _tokenFiador = window.__token_tokenFiador__;
//  eh setado na View.cshtml
var _solSeq = window.__solSeq__;

let api = {
    getEstados() {
        return ["AC", "AL", "AM", "AP", "BA", "CE", "DF",
            "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB",
            "PE", "PI", "PR", "RJ", "RN", "RO", "RR",
            "RS", "SC", "SE", "SP", "TO"];
    },



    separaListasFinanciamento: (list) => {

        var listCursos = [];
        var listPeriodo = [];
        var listPolo = [];

        list.forEach((c) => {
            if (listCursos.every((item) => {
                return item.cur_codigo != c.cur_codigo;
            })) {
                listCursos.push({
                    // per_seq: c.per_seq,
                    cur_url: c.cur_url,
                    cur_codigo: c.cur_codigo,
                    cur_nomcur: c.cur_nomcur
                });
            }

            if (listPeriodo.every((item) => {
                return item.per_periodo != c.per_periodo;
            })) {
                listPeriodo.push({
                    //per_seq: c.per_seq,
                    per_periodo: c.per_periodo,
                    per_descricao: c.per_descricao
                });
            }

            if (listPolo.every((item) => {
                return item.pol_codigo != c.pol_codigo;
            })) {
                listPolo.push({
                    /// per_seq: c.per_seq,
                    //  per_maxpercent: c.per_maxpercent,
                    pol_codigo: c.pol_codigo,
                    pol_descricao: c.pol_descricao
                });
            }
        });

        return {
            listAllFinanciamentos: list,
            listCursos,
            listPeriodo,
            listPolo
        };
    },

    getCursoByCurCodigo(listAllFinanciamentos, curCodigo) {
        var lists = this.separaListasFinanciamento(listAllFinanciamentos);
        var c = lists.listCursos.filter((curso) => {
            return curso.cur_codigo == curCodigo;
        });
        if (c.length > 0) {
            return c[0];
        }
        return null;
    },

    getPeriodoByPerPeriodo(listAllFinanciamentos, perPeriodo) {
        var lists = this.separaListasFinanciamento(listAllFinanciamentos);
        var p = lists.listPeriodo.filter((periodo) => {
            return periodo.per_periodo == perPeriodo;
        });
        if (p.length > 0) {
            return p[0];
        }
        return null;
    },

    getPoloByPolCodigo(listAllFinanciamentos, polCodigo) {
        var lists = this.separaListasFinanciamento(listAllFinanciamentos);
        var p = lists.listPolo.filter((polo) => {
            return polo.pol_codigo == polCodigo;
        });
        if (p.length > 0) {
            return p[0];
        }
        return null;
    },

    getPeriodosByCurso(listAllFinanciamentos, curCodigo) {
        var lists = this.separaListasFinanciamento(listAllFinanciamentos);
        return lists.listPeriodo.filter((periodo) => {
            return listAllFinanciamentos.some((linha) => {
                return periodo.per_periodo === linha.per_periodo && linha.cur_codigo === curCodigo;
            });
        });
    },

    getPolosByCursoPeriodo(listAllFinanciamentos, curCodigo, perPeriodo) {
        var lists = this.separaListasFinanciamento(listAllFinanciamentos);
        return lists.listPolo.filter((polo) => {
            return listAllFinanciamentos.some((linha) => {
                return polo.pol_codigo === linha.pol_codigo && linha.cur_codigo === curCodigo && linha.per_periodo === perPeriodo;
            });
        });
    },
    getArquivo: (solSeqCript2, uplSeq) => {
        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/GetArquivo?solSeqCript2=" + solSeqCript2 + "&uplSeq=" + uplSeq;
            http(url, {
                method: 'POST',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {

                resolve(response);

            }).catch(reject);
        });
    },
    getDadosFormFiadores: () => {
        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/Fiadores/GetDadosParaFormFiadores?solSeq=" + _solSeq + "&tokenFiador=" + _tokenFiador;
            http(url, {
                method: 'POST',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {

                resolve(response);

            }).catch(reject);
        });
    },

    carregarFinanciamentosdisponiveis: () => {
        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/GetFinanciamentosDisponiveis";
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve(api.separaListasFinanciamento(response));

            }).catch(reject);
        });
    },

    getListTpMoradia: () => {
        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/GetListTpMoradia";
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    getNacionalidade: () => {
        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/GetNacionalidade";
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    getListParentesco: () => {
        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/GetListParentesco";
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve(response.map((item) => {
                    return {
                        value: item.par_seq,
                        text: item.par_descricao
                    };
                }));
            }).catch(reject);
        });
    },
    getListDeficiencia: () => {
        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/GetListDeficiencia";
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    // getPessoasPorCpf: (cpf) => {
    //     return new Promise((resolve, reject) => {
    //         var url = "/BolsasFinanciamentos/RetornarPessoasPorCpf?cpf=" + cpf;
    //         http(url, {
    //             method: 'GET',
    //             headers: {
    //                 'X-TOKEN': _token
    //             }
    //         }).then((response) => {
    //             resolve({
    //                 dadosPessoa: response.pessoa.length > 0 ? response.pessoa[0] : null,
    //                 permissaoAlterar: response.permissaoAlterar
    //             });
    //         }).catch(reject);
    //     });
    // },

    getPessoasPorCpf: (cpf) => {
        return new Promise((resolve, reject) => {
            var url = "/UnoesteApi/api/Unoeste/Pessoa/RetornarPessoasPorCpf?cpf=" + cpf;
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve({
                    dadosPessoa: response.pessoa,
                    permissaoAlterar: response.permissaoAlterar,
                    dadosPessoaNormalizado: _mapearPropriedadesPessoa(response.pessoa, true)
                });
            }).catch(reject);
        });
    },

    aindaNaoPossuiCadastro: (cpf) => {
        var url = "/BolsasFinanciamentos/Unocred/GetDadosParaAlteracao?cpf=" + cpf;
        return new Promise((resolve, reject) => {
            http(url, {
                method: 'POST',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                if (!response.possuiCadastro) {
                    resolve(response);
                    return;
                }
                reject(new Error("CPF Já possui Solicitação neste ano/semestre"));
            }).catch(reject);
        });
    },

    getDadosParaAlteracao: (cpf) => {
        var url = "/BolsasFinanciamentos/Unocred/GetDadosParaAlteracao?cpf=" + cpf;
        return new Promise((resolve, reject) => {
            http(url, {
                method: 'POST',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                if (response.possuiCadastro) {
                    resolve(response);
                    return;
                }
                reject(new Error("Nenhuma solicitação neste ano/semestre"));
            }).catch(reject);
        });
    },

    getCidadesByUf: (uf) => {
        return new Promise((resolve, reject) => {
            var url = "/UnoesteApi/api/CEP/CEP/GetCidadesByUf?uf=" + uf;
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                resolve(response);
            }).catch(reject);
        });
    },

    consultaCEP: (cep) => {
        return new Promise((resolve, reject) => {
            var url = "/UnoesteApi/api/CEP/CEP/ConsultaCEP?cep=" + cep;
            http(url, {
                method: 'GET',
                headers: {
                    'X-TOKEN': _token
                }
            }).then((response) => {
                if (response.ExceptionMessage) {
                    reject(new Error(response.ExceptionMessage));
                    return;
                }
                /*
                    bairro : "Parque Residencial Servantes"
                    cidade : "Presidente Prudente" 
                    complemento : "" 
                    complemento2 : "" 
                    rua : "Rua Isaac Melem" 
                    uf : "SP
                */
                resolve(response);
            }).catch(reject);
        });
    },

    gravaArquivos(solSeqCript2, origem, listArquivos, fnProgress) {
         
        if (listArquivos.length === 0) {
            return Promise.resolve();
        }
        listArquivos = listArquivos.map((item, indice) => {
            var form = new FormData();
            var ok = true;
            return new Promise((resolve, reject) => {
                var url = "/BolsasFinanciamentos/Unocred/GravarArquivoFamiliar";
                if (origem === 'F') {
                    url = "/BolsasFinanciamentos/Unocred/GravarArquivoFiador";
                }
                delete item.UplBytes;
                let json = JSON.stringify({objFinanciamentoUpload: item});
                form.append("solSeqCript2", solSeqCript2);
                form.append("json", json);
                http(url, {
                    upload: true,
                    method: 'POST',
                    headers: {
                        'X-TOKEN': _token
                    },
                    body: form
                }).then((response) => {
                    if (response.ok) {
                        resolve();
                        fnProgress(item);
                        return;
                    }
                    throw new Error('errro');
                }).catch((ee) => {
                    console.error(ee);
                    reject(new Error('Erro ao gravar arquivo ' + item.UplDescricao));
                });
            });
        });
        return Promise.all(listArquivos);
    },


    finalizarFinanciamentoInterno: (captcha, solSeq, cursoInteresse, dadosInteressado, grupoFamiliar) => {
        let form = new FormData();



        var json = JSON.stringify({
            captcha: captcha,
            solSeq: solSeq,
            ...cursoInteresse,
            ...dadosInteressado,
            ...grupoFamiliar
        });
        form.append('json', json);


        // var blob = new Blob([json], { type: "application/json; charset=UTF-8" });
        // var a = document.createElement('a');
        // var url = window.URL.createObjectURL(blob);
        // a.href = url;
        // a.download = "_arquivo_" + (new Date()).getTime() + ".json";
        // document.body.appendChild(a);
        // a.click()

        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/FinalizarFinanciamentoInterno";
            http(url, {
                upload: true,
                method: 'POST',
                headers: {
                    'X-TOKEN': _token
                },
                body: form
            }).then((response) => {
                if (response.ok) {
                    resolve({ msg: response.msg, solSeqCript2: response.solSeqCript2 });
                    return;
                }
                reject(new Error(response.error || "Erro ao finalizar"));

            }).catch(reject);
        });
    },

    // finalizarFinanciamentoInterno: (captcha, solSeq, cursoInteresse, dadosInteressado, grupoFamiliar) => {
    //     return new Promise((resolve, reject) => {
    //         var url = "/BolsasFinanciamentos/FinalizarFinanciamentoInterno";
    //         http(url, {
    //             method: 'POST',
    //             headers: {
    //                 'X-TOKEN': _token
    //             },
    //             body: {
    //                 captcha: captcha,
    //                 solSeq: solSeq,
    //                 ...cursoInteresse,
    //                 ...dadosInteressado,
    //                 ...grupoFamiliar
    //             }
    //         }).then((response) => {
    //             if (response.ok) {
    //                 resolve(response.msg);
    //                 return;
    //             }

    //             reject(new Error(response.error || "Erro ao finalizar"));

    //         }).catch(reject);
    //     });
    // },

    /*
      public JsonResult ConcluirEnvioFiadores(
           int solSeq,
           string tokenFiador,
           FinanciamentoInternoPessoa pessoaResponsavel,
           List<FinanciamentoInternoPessoa> listFiadores) {    
    */
    concluirEnvioFiadores: (solSeq, pessoaResponsavel, listFiadores) => {
        pessoaResponsavel = _mapearPropriedadesPessoa(pessoaResponsavel);
        listFiadores = listFiadores.map((item) => {
            return _mapearPropriedadesPessoa(item);
        });
        //==================================================================
        //gambi pois o MVC não ta fazendo parse de objetos aninhados    
        let listFiadoresConjuge = [];
        let pessoaResponsavelConjuge = null;
        listFiadoresConjuge = listFiadores.map((fiador) => {
            return fiador.PessoaConjuge;
        });
        if (pessoaResponsavel) {
            pessoaResponsavelConjuge = pessoaResponsavel.PessoaConjuge
        }
        //==================================================================
        var json = JSON.stringify({
  
            tokenFiador: _tokenFiador,
            solSeq: solSeq,
            pessoaResponsavel: pessoaResponsavel,
            pessoaResponsavelConjuge: pessoaResponsavelConjuge,
            listFiadores: listFiadores,
            listFiadoresConjuge: listFiadoresConjuge
        });
       


        return new Promise((resolve, reject) => {
            var url = "/BolsasFinanciamentos/Unocred/ConcluirEnvioFiadores";
            let form = new FormData();
            form.append('json', json);

            http(url, {
                upload: true,
                method: 'POST',
                headers: {
                    'X-TOKEN': _token
                },
                body: form
            }).then((response) => {
                if (response.ok) {
                    resolve({
                        solSeqCript2: response.solSeqCript2,
                        msgSucesso: response.msg
                    });
                    return;
                }
                reject(new Error(response.error || "Erro ao concluirEnvioFiadores"));
            }).catch(reject);
        });
    },
};

//======================================

export const _createStatePessoa = (tipoPessoa) => {
    return {
        fiaSeq: 0,
        uf: "",
        carregandoCidades: false,
        carregandoCEP: false,
        locCodigo: "",
        cidadeCEP: "",
        cpfOK: false,
        pesNro: "",
        bloquearTudo: false,
        permissaoAlterar: -1,
        carregandoPessoaCPF: false,
        pesCPF: "",
        pesSexo: "0",
        pesNome: "",
        nacCodigo: "",
        emlEmail: "",
        pesDtNasc: "",
        pesRG: "",
        pesEstExp: "",
        pesOrgExp: "",
        pesTelefone: "",
        pesCelular: "",
        pesBairro: "",
        pesCEP: "",
        pesRua: "",
        listCidades: [],
        tipSeq: 0,// moradia
        pesEmpresa: "",
        pesDtAdmissao: "",
        pesCargo: "",
        pesRendaBruta: "",
        pesEstCiv: "",
        conjuge: tipoPessoa === CONSTANTS._TIPO_PESSOA.CONJUGE ? null : _createStatePessoa(CONSTANTS._TIPO_PESSOA.CONJUGE),
        tipoPessoaFinanciamento: tipoPessoa,
        campoErros: {}
    };
};

export let _mapearPropriedadesPessoa = (objPessoa, servidorParaClient) => {

    if (!objPessoa) {
        console.warn('nULLLLLLLL');
        return null;
    }
    let propsPessoaServer = {
        BloquearTudo: 'bloquearTudo',
        TipoMoradiaSeq: 'tipSeq', //tipSeq moradia   
        FiaSeq: 'fiaSeq',
        LocCodigo: 'locCodigo',
        LocUf: 'uf',
        PesBairro: 'pesBairro',
        PesCargo: 'pesCargo',
        PesCelular: 'pesCelular',
        PesSexo: 'pesSexo',
        PesCep: 'pesCEP',
        PesCpf: 'pesCPF',
        PesDatnas: 'pesDtNasc',
        PesDtAdmissao: 'pesDtAdmissao',
        PesEmpresa: 'pesEmpresa',
        PesEstCiv: 'pesEstCiv',
        PesEstExp: 'pesEstExp',
        NacCodigo: 'nacCodigo',
        PesNome: 'pesNome',
        PesNro: 'pesNro',
        PesOrgExp: 'pesOrgExp',
        PesRendaBruta: 'pesRendaBruta',
        PesRg: 'pesRG',
        PesRua: 'pesRua',
        PesTelefone: 'pesTelefone',
        PessoaConjuge: 'conjuge',//,
        TipoPessoaFinanciamento: 'tipoPessoaFinanciamento',
        PermissaoAlterar: 'permissaoAlterar'
    };

    let objFinal = {};
    if (servidorParaClient) {
        if (objPessoa.PesCpf) {
            objFinal.cpfOK = true;
        }
        if (!objPessoa.PesTelefone && objPessoa.PesCelular) {
            objPessoa.PesTelefone = objPessoa.PesCelular;
        }
    }
    Object.keys(propsPessoaServer).forEach((propServer) => {
        let propClient = propsPessoaServer[propServer];
        let propDe = propClient;
        let propPara = propServer;
        if (servidorParaClient) {
            propDe = propServer;
            propPara = propClient;
        }
        let valorFinal = objPessoa[propDe];
        if (propServer === 'PessoaConjuge') {
            valorFinal = _mapearPropriedadesPessoa(objPessoa[propDe], servidorParaClient);
        }

        if (propDe === 'PesDtAdmissao' || propDe === 'PesDatnas') {
            valorFinal = formataDataWebMethodParaString(objPessoa[propDe]);
        }

        objFinal[propPara] = valorFinal;
    });

    return objFinal;
};
//======================================


export default api;


// WEBPACK FOOTER //
// ./src/modules/api.js